import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=84971a7a&"
import script from "./ClientList.vue?vue&type=script&lang=ts&"
export * from "./ClientList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84971a7a')) {
      api.createRecord('84971a7a', component.options)
    } else {
      api.reload('84971a7a', component.options)
    }
    module.hot.accept("./ClientList.vue?vue&type=template&id=84971a7a&", function () {
      api.rerender('84971a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientList.vue"
export default component.exports